/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import classnames from "classnames";
import styles from "ui/style/typography.module.scss";

interface Props {
    children: React.ReactNode;
    className?: string;
}

const Header2: React.FC<Props> = ({children, className}) => {
    return (
        <p className={classnames(styles.header2, className)}>{children}</p>
    )
}

export default Header2;
